import { MakePaths } from "common/router/types";
import { makeRoutes, MakeRoutesOpts } from "common/router/utils/routes";
import { makeUrls } from "common/router/utils/urls";

import { CheckoutErrorSearch, KlarnaCheckoutSearch, CheckoutStep } from "../types";

const paths = {
  start: "/",
  detail: "/:step",
  confirmation: "/confirmed",
  error: "/error",
};

type CheckoutParams = {
  step: CheckoutStep;
};

type CheckoutPathDefinitions = {
  start: {};
  detail: { Params: CheckoutParams; Search: KlarnaCheckoutSearch };
  confirmation: {};
  error: { Search: CheckoutErrorSearch };
};

export type CheckoutPaths = MakePaths<CheckoutPathDefinitions>;

export const useCheckoutRoutes = (opts: MakeRoutesOpts) => {
  return makeRoutes({ ...opts }, [
    { path: paths.start, element: () => import("../components/CheckoutRoot") },
    { path: paths.confirmation, element: () => import("../components/OrderConfirmationPage") },
    { path: paths.error, element: () => import("../components/CheckoutErrorPage") },
    { path: paths.detail, element: () => import("../components/Checkout") },
  ]);
};

export const makeCheckoutUrls = (base: string) => {
  return makeUrls<CheckoutPathDefinitions>(base, {
    start: { path: paths.start, to: () => `/` },
    detail: { path: paths.detail, to: ({ step }) => `/${step}` },
    confirmation: { path: paths.confirmation },
    error: { path: paths.error },
  });
};
